import appModel from './App';
import formModel from './Form';

const storeModel = {
  app: appModel,
  form: formModel,
};

export default storeModel;